export const dateDifference = (startDate: Date, endDate: Date): string => {
  const diff: number = Math.abs(endDate.getTime() - startDate.getTime()) / 1000;

  const days: number = Math.floor(diff / 86400);
  let remainingSeconds: number = diff - days * 86400;

  const hours: number = Math.floor(remainingSeconds / 3600) % 24;
  remainingSeconds -= hours * 3600;

  const minutes: number = Math.floor(remainingSeconds / 60) % 60;
  remainingSeconds -= minutes * 60;

  const seconds: number = Math.floor(remainingSeconds % 60);

  let stringBuilder = '';

  if (days > 0) {
    stringBuilder = `${days}d`;
  }

  if (hours > 0) {
    stringBuilder += ` ${hours}h`;
  }

  if (minutes > 0) {
    stringBuilder += ` ${minutes}min`;
  }

  if (seconds > 0) {
    stringBuilder += ` ${seconds}sec`;
  }

  return stringBuilder;
};
